import { useLocalStorageState } from 'ahooks';
import { useState } from 'react';
import type { TimeRange, TimeRangeValue, ViewOption } from '../types';

interface UseOverviewMetricDatetimeOptions {
	cacheKey?: string;
}

export function useOverviewMetricDatetime(
	options: UseOverviewMetricDatetimeOptions = {}
) {
	const { cacheKey } = options;
	const pathKey = btoa(window.location.pathname);
	const storageKeyPrefix = `overview-metrics-${pathKey}${cacheKey ? `-${cacheKey}` : ''}`;
	const dateRangeOptionKey = `${storageKeyPrefix}-dateRangeOption`;
	const dateFilterKey = `${storageKeyPrefix}-dateFilter`;

	const [dateRangeOption, setDateRangeOption] =
		// eslint-disable-next-line no-local-storage/no-local-storage
		useLocalStorageState<ViewOption>(dateRangeOptionKey, {
			defaultValue: 'day',
		});

	// eslint-disable-next-line no-local-storage/no-local-storage
	const [dateFilter, setDateFilter] = useLocalStorageState<TimeRange>(
		dateFilterKey,
		{
			defaultValue: '30d',
		}
	);

	const today = new Date();
	const [timeRangeValue, setTimeRangeValue] = useState<TimeRangeValue>({
		timeRange: '30d',
		dateRange: {
			from: today,
			to: today,
		},
	});

	return {
		today,
		timeRangeValue,
		setTimeRangeValue,
		dateRangeOption,
		setDateRangeOption,
		dateFilter,
		setDateFilter,
	};
}
